/**
 * Biker BFF API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';

/**
 * The CustomersIdCommunicationpreferencesCommunicationpreferenceIdPutRequest model module.
 * @module model/CustomersIdCommunicationpreferencesCommunicationpreferenceIdPutRequest
 * @version 1.0.0
 */
class CustomersIdCommunicationpreferencesCommunicationpreferenceIdPutRequest {
    /**
     * Constructs a new <code>CustomersIdCommunicationpreferencesCommunicationpreferenceIdPutRequest</code>.
     * @alias module:model/CustomersIdCommunicationpreferencesCommunicationpreferenceIdPutRequest
     */
    constructor() { 
        
        CustomersIdCommunicationpreferencesCommunicationpreferenceIdPutRequest.initialize(this);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj) { 
    }

    /**
     * Constructs a <code>CustomersIdCommunicationpreferencesCommunicationpreferenceIdPutRequest</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/CustomersIdCommunicationpreferencesCommunicationpreferenceIdPutRequest} obj Optional instance to populate.
     * @return {module:model/CustomersIdCommunicationpreferencesCommunicationpreferenceIdPutRequest} The populated <code>CustomersIdCommunicationpreferencesCommunicationpreferenceIdPutRequest</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new CustomersIdCommunicationpreferencesCommunicationpreferenceIdPutRequest();

            if (data.hasOwnProperty('id')) {
                obj['id'] = ApiClient.convertToType(data['id'], 'Number');
            }
            if (data.hasOwnProperty('smsNumber')) {
                obj['smsNumber'] = ApiClient.convertToType(data['smsNumber'], 'String');
            }
            if (data.hasOwnProperty('smsNumberCountryCode')) {
                obj['smsNumberCountryCode'] = ApiClient.convertToType(data['smsNumberCountryCode'], 'String');
            }
            if (data.hasOwnProperty('emailAddress')) {
                obj['emailAddress'] = ApiClient.convertToType(data['emailAddress'], 'String');
            }
            if (data.hasOwnProperty('receivePushNotifications')) {
                obj['receivePushNotifications'] = ApiClient.convertToType(data['receivePushNotifications'], 'Boolean');
            }
            if (data.hasOwnProperty('receiveSms')) {
                obj['receiveSms'] = ApiClient.convertToType(data['receiveSms'], 'Boolean');
            }
            if (data.hasOwnProperty('receiveEmail')) {
                obj['receiveEmail'] = ApiClient.convertToType(data['receiveEmail'], 'Boolean');
            }
        }
        return obj;
    }

    /**
     * Validates the JSON data with respect to <code>CustomersIdCommunicationpreferencesCommunicationpreferenceIdPutRequest</code>.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @return {boolean} to indicate whether the JSON data is valid with respect to <code>CustomersIdCommunicationpreferencesCommunicationpreferenceIdPutRequest</code>.
     */
    static validateJSON(data) {
        // ensure the json data is a string
        if (data['smsNumber'] && !(typeof data['smsNumber'] === 'string' || data['smsNumber'] instanceof String)) {
            throw new Error("Expected the field `smsNumber` to be a primitive type in the JSON string but got " + data['smsNumber']);
        }
        // ensure the json data is a string
        if (data['smsNumberCountryCode'] && !(typeof data['smsNumberCountryCode'] === 'string' || data['smsNumberCountryCode'] instanceof String)) {
            throw new Error("Expected the field `smsNumberCountryCode` to be a primitive type in the JSON string but got " + data['smsNumberCountryCode']);
        }
        // ensure the json data is a string
        if (data['emailAddress'] && !(typeof data['emailAddress'] === 'string' || data['emailAddress'] instanceof String)) {
            throw new Error("Expected the field `emailAddress` to be a primitive type in the JSON string but got " + data['emailAddress']);
        }

        return true;
    }


}



/**
 * @member {Number} id
 */
CustomersIdCommunicationpreferencesCommunicationpreferenceIdPutRequest.prototype['id'] = undefined;

/**
 * @member {String} smsNumber
 */
CustomersIdCommunicationpreferencesCommunicationpreferenceIdPutRequest.prototype['smsNumber'] = undefined;

/**
 * @member {String} smsNumberCountryCode
 */
CustomersIdCommunicationpreferencesCommunicationpreferenceIdPutRequest.prototype['smsNumberCountryCode'] = undefined;

/**
 * @member {String} emailAddress
 */
CustomersIdCommunicationpreferencesCommunicationpreferenceIdPutRequest.prototype['emailAddress'] = undefined;

/**
 * @member {Boolean} receivePushNotifications
 */
CustomersIdCommunicationpreferencesCommunicationpreferenceIdPutRequest.prototype['receivePushNotifications'] = undefined;

/**
 * @member {Boolean} receiveSms
 */
CustomersIdCommunicationpreferencesCommunicationpreferenceIdPutRequest.prototype['receiveSms'] = undefined;

/**
 * @member {Boolean} receiveEmail
 */
CustomersIdCommunicationpreferencesCommunicationpreferenceIdPutRequest.prototype['receiveEmail'] = undefined;






export default CustomersIdCommunicationpreferencesCommunicationpreferenceIdPutRequest;

